import React, { useState, useEffect } from 'react'
import { Trans } from '@lingui/macro'
import debug from 'debug'
import { apolloClientPublic } from 'front-end/src/graphql/apolloClient'
import { useLooopTheme } from '../../../public-api/hooks/useLooopTheme'
import { ReleasedVersionDocument } from './UpdatePopup.codegen'
import { Box, ButtonPrimary } from 'front-end/src/components'
import { css, Global } from '@emotion/react'
import { brandColors } from 'shared/basicPalette'

import { isColorDark } from 'shared/colorUtils'

const log = debug('looop')

const UpdatePopup = () => {
  const { theme } = useLooopTheme()

  if (process.env.LOOOP_ENVIRONMENT === 'dev') {
    log('UpdatePopup component is ignored in dev environment.')
    return null
  }
  const [isNewerVersionAvailable, setIsNewerVersionAvailable] = useState(false)

  useEffect(() => {
    const interval = setInterval(async () => {
      const response = await apolloClientPublic.query({
        query: ReleasedVersionDocument
      })
      setIsNewerVersionAvailable(
        window.LOOOP.releasedGitHash !== response.data.releasedVersion
      )
    }, 15 * 60000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const heightOfPanel = 56

  return isNewerVersionAvailable ? (
    <>
      {/* Affect position of Main header and content below */}
      <Global
        styles={css`
          header.MainHeader {
            top: ${heightOfPanel}px;
          }
          .reactSpring__transition__wrapper {
            margin-top: ${80 + heightOfPanel}px;
            height: calc(100% - 80px - ${heightOfPanel}px - 1px);
          }
        `}
      />
      <Box
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: ${heightOfPanel}px;
          line-height: ${heightOfPanel}px;
          text-align: center;
          background-color: ${theme.colors.buttonPrimary.default};
          box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
          color: white;
          z-index: 5000;

          .icon {
            font-size: 18px;
            position: relative;
            top: 4px;
            left: -4px;
          }
          .btn {
            margin-left: 8px;
          }
        `}
        className="new-release-message"
      >
        <Trans>An update is available</Trans>
        <ButtonPrimary
          ml="12px"
          border={`1px solid ${
            isColorDark(theme.colors.buttonPrimary.default)
              ? brandColors.white
              : brandColors.grey.dark
          }`}
          onClick={() => window.location.reload()}
          size="sm"
        >
          <Trans>Update Now</Trans>
        </ButtonPrimary>
      </Box>
    </>
  ) : null
}

export default UpdatePopup
